// New ones need to be added by Dustin and are product-led
export enum Entitlement {
	IntegrationsInstall = 'sharefile:entitlementdef-integration-install',
}
